import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useGetEmployeeInvitesQuery = ({ limit, offset }: { offset: number; limit: number }) => {
  return useQuery({
    queryKey: ['getEmployeeInvites', limit, offset],
    queryFn: () => Api.users.getUserInvitations({ limit, offset }),
  });
};
